import React from 'react';
import Message from '../Message';
import Layout from '@rezdy/components/Layout/DarkCentered';
import { Article, Aside, Body } from '@rezdy/components/Layout/Article/Styled';
import Button from '@rezdy/components/Button';
import CreatePassword from '../CreatePassword';
import Field from '@rezdy/components/Form/Field';
import TextInput from '@rezdy/components/Form/FormElements/TextInput';
import Grid from '@rezdy/components/Grid';
import Card from './Layout/Card';
import Form from '@rezdy/components/Form';
import { getRecaptcha } from '../../services/recaptcha';
import SecondaryAction from './SecondaryAction';
import TextStyle from '@rezdy/components/TextStyle';
import AvatarCard from '../AvatarCard';
import { Title } from './Styled';
import { ErrorMessage } from '../ErrorMessage';
import { withTranslation, WithTranslation } from 'react-i18next';

interface IProps extends WithTranslation {
    action: (formData: any) => void;
    context: string;
}

interface IState {
    isLoading: boolean;
    isDirty: boolean;
    message: string;
}

class SignUpWithEmail extends React.PureComponent<IProps, IState> {
    card = {
        cardPhoto: '/img/signup-img.jpg',
        // eslint-disable-next-line prettier/prettier
        description:
            'Rezdy saves us a significant amount of time which lets us focus on sailing, which is the main thing for us.',
        avatarCard: {
            avatar: '/img/signup-avatar.jpg',
            company: 'Owner, Manly Sailing',
            name: 'Finn Irvine',
            rating: 6,
        },
    };

    state = {
        isLoading: false,
        isDirty: false,
        message: '',
    };

    componentDidMount() {
        getRecaptcha().render();
    }

    onSubmit = (formData: any) => {
        const { action } = this.props;
        const { isLoading } = this.state;

        if (!isLoading) {
            this.setState({ isLoading: true }, async () => {
                try {
                    await action(formData);
                } catch (error) {
                    this.setState({
                        isDirty: true,
                        isLoading: false,
                        message: error.message,
                    });
                }
            });
        }
    };

    renderFormMsg = () => {
        const { isDirty, message } = this.state;
        if (message) {
            return <ErrorMessage as="p" isDirty={isDirty} align="center" i18nKey={message} />;
        }
        return null;
    };

    renderForm = () => {
        const { isLoading } = this.state;
        const { i18n } = this.props;
        return (
            <Form onSubmit={this.onSubmit}>
                <Grid.Container rowGap="24px" style={{ maxWidth: 400 }}>
                    <Title>Get started with email</Title>
                    {this.renderFormMsg()}
                    <Grid.Container cols="repeat(auto-fit, minmax(140px, 1fr))" colGap="8px">
                        <Grid.Cell>
                            <Field label={i18n.t('firstname')} name="firstname">
                                <TextInput />
                            </Field>
                        </Grid.Cell>
                        <Grid.Cell>
                            <Field label={i18n.t('lastname')} name="lastname">
                                <TextInput />
                            </Field>
                        </Grid.Cell>
                    </Grid.Container>
                    <Field label={i18n.t('username')} name="username">
                        <TextInput />
                    </Field>
                    <CreatePassword />
                    <Button
                        type="submit"
                        action="primary"
                        loading={isLoading}
                        width="100%"
                        tight
                        name="customer-signup-complete"
                    >
                        {i18n.t('primaryAction', { context: 'getStarted' })}
                    </Button>
                </Grid.Container>
            </Form>
        );
    };

    renderCard = () => {
        return (
            <Card photo={this.card.cardPhoto}>
                <Grid.Container rowGap>
                    <Grid.Cell>
                        <TextStyle>{this.card.description}</TextStyle>
                    </Grid.Cell>
                    <Grid.Cell>
                        <AvatarCard {...this.card.avatarCard} />
                    </Grid.Cell>
                </Grid.Container>
            </Card>
        );
    };

    render() {
        return (
            <Layout secondaryAction={<SecondaryAction {...this.props} />}>
                <Article>
                    <Body>{this.renderForm()}</Body>
                    <Aside>{this.renderCard()}</Aside>
                </Article>
            </Layout>
        );
    }
}

export default withTranslation()(SignUpWithEmail);
